import DataTable from 'datatables.net-react';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import Swal from 'sweetalert2';
import * as BullCache from "../../util/BullCache";
import MarketDropdown from '../components/MarketDropdown';
import ScriptDropdown from '../components/ScriptDropdown';
import { ScriptConfigService } from '../../services/ScriptConfigService';
import {showToast} from "../../util/Utils"

function ScriptConfig() {

    var allScripts = BullCache.getFromCache('allScripts');
    var user = BullCache.getFromCache("user");

    const [loading, setLoading] = useState(false); 
    const [selectedMarket, setSelectedMarket] = useState('');  
    const [selectedScript, setSelectedScript] = useState(''); 
    const [scriptList, setScriptList] = useState([]);
    const [filteredScriptMarginList, setFilteredScriptMarginList] = useState([]);

    const fetchScriptMarginList = (request) => {
        setLoading(true);     
        ScriptConfigService.getScriptConfigs(request).then(res => {
        setLoading(false);
            if (res.code === 1) {
                const allLists = Object.values(res.data.scripts).flat();
                setScriptList(Object.values(res.data.blockedList).flat());
                setFilteredScriptMarginList(allLists);
            }
        });
    };

    useEffect(() => {
      fetchScriptMarginList({ 'adminId': user.adminId });  
    }, []); 

    const handleMarketChange = (market) => {
      setSelectedMarket(market); 
  };

  const handleScriptChange = (script) => {
      setSelectedScript(script); 
  };
  const handleScriptReset = () => {
    setSelectedScript(null); 
  };
    
    const handleSaveChanges = () => {

            const selectedData = {
                adminId: user.adminId,
                scripts: scriptList
            };
        
            ScriptConfigService.blockScriptConfigs(selectedData)
                .then(res => {
                    if (res && res.code === 1) {
                        showToast("success", "Updated Successfully..");
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            text: "Failed to update script config!"
                        });
                    }
                })
                .catch(error => {
                   Swal.fire({
                            icon: "error",
                            text: "Failed to update script config!"
                        });
                });
        };
    

        const handleSearch = () => {

             fetchScriptMarginList({ 'adminId': user.adminId, segment: selectedMarket, keyword: selectedScript });  

        };

    useEffect(() => {
        const handleDocumentClick = (event) => {
            const target = event.target;

            // Checkbox Click Logic
            if (target.tagName === "INPUT" && target.type === "checkbox") {
            const scriptId = target.getAttribute("data-id");
            const isChecked = target.checked;

            setScriptList((prev) =>
                !isChecked ? [...prev, scriptId] : prev.filter((id) => id !== scriptId)
            );
            }
         
        };

        document.addEventListener("click", handleDocumentClick);
        return () => {
            document.removeEventListener("click", handleDocumentClick);
        };
     }, [filteredScriptMarginList]);

    const columns = [
     { 
        title: 'TRADE ALLOWED', 
        data: 'tradeAllowed', 
        className: 'font-bold text-center',
         render: (data, type, row, full, meta) => {
          return `
          <input type="checkbox" class="me-3" data-id="${row.id}" style="cursor: pointer" ${data ? 'checked' : ''} />
        `;
        },
      },
      { 
        title: 'MARKET', 
        data: 'segment', 
        className: 'font-bold'
      },
      {
         title: 'SCRIPT',
         data: 'script',
         className: 'font-bold'
      },
      {
            title: 'EXPIRY DATE',
            data: 'expiryDate',
            className: 'font-bold'
      },
      {
         title: 'LAST UPDATED', 
         data: 'auditTimestamp',    
         className: 'font-bold'
      }
    ]


    return (
        <div>

            <Card className='mt-2'>
                <Card.Body>
                    <Row>
                        
                        <Col className=' mt-2' xs={4} sm={2}>
                        <b className='fss-05'>MARKET</b>
                            <MarketDropdown
                                allScripts={allScripts}
                                onMarketChange={handleMarketChange}
                                onScriptReset={handleScriptReset} />
                        </Col>

                        <Col className=' mt-2' xs={4} sm={2}>
                        <b className='fss-05'>SCRIPT NAME</b>

                            <ScriptDropdown
                                allScripts={allScripts}
                                selectedMarket={selectedMarket}
                                onScriptChange={handleScriptChange}
                            />
                        </Col>

                        <Col xs={4} sm={1} className=' mt-2'>
                            <Button variant="success" size="sm" className='mt-4' onClick={handleSearch}>
                                Search
                            </Button>
                        </Col>
                         <Col xs={4} md={1} sm={2} className=' mt-2'>
                            <Button variant="success" size="sm" className='mt-4 w-75' onClick={handleSaveChanges}>
                                Save
                            </Button>
                        </Col>                                                
                    </Row>

                </Card.Body>
            </Card>

            <Card className="mt-2 mb-5">
                <Card.Body>
                    <div className="table-responsive">
                        {loading ? (
                            <div className="container vh-100">
                                <div className="d-flex align-items-center justify-content-center h-90">
                                    <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <DataTable
                                id="table"
                                className=" table  table-bordered bg-head-secondary fss-05 white-bordered-table"
                                columns={columns}
                                data={filteredScriptMarginList}

                            />
                        )}
                    </div>
                </Card.Body>
            </Card>

        </div>
    );
}
export default ScriptConfig;